<main class="not-found-page" aria-labelledby="not-found-title">
  <div class="not-found-card">
    <p class="not-found-code">404</p>
    <h1 id="not-found-title">{{ 'Nie możemy znaleźć tej strony' | translate }}</h1>
    <p class="not-found-copy">
      {{ 'Strona mogła zostać przeniesiona lub adres jest nieprawidłowy. Skorzystaj z jednego z poniższych odnośników.' | translate }}
    </p>
    <div class="not-found-actions">
      <a routerLink="/" class="primary-action">{{ 'Wróć na stronę główną' | translate }}</a>
      <a routerLink="/products" class="secondary-action">{{ 'Przeglądaj produkty' | translate }}</a>
    </div>
  </div>
</main>
